import { render } from "./legoPageTable.vue?vue&type=template&id=684489e5"
import script from "./legoPageTable.vue?vue&type=script&lang=js"
export * from "./legoPageTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoTable/legoPageTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "684489e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('684489e5', __exports__)) {
    api.reload('684489e5', __exports__)
  }
  
  module.hot.accept("./legoPageTable.vue?vue&type=template&id=684489e5", () => {
    api.rerender('684489e5', render)
  })

}


export default __exports__